// @ts-nocheck -- Legacy JavaScript compatibility boundary; runtime behavior intentionally preserved.
import { useEffect, useState } from "react";
import Image from "next/image";
import { Box, Button, Grid, Typography, Radio } from "@mui/material";

import { useSecurityImageStore } from "@/store/login/security-image";
import { useUserInfoStore } from "@/store/login/user-info";
import { MessageDialog } from "@/components/common";

export default function SecurityImage() {
  const [openDialog, setOpenDialog] = useState(false);

  const { getSecurityImages, images, selectSecurityImages, insertSecurityImages, selectedImage } =
    useSecurityImageStore();
  const { data: userInfo } = useUserInfoStore();

  useEffect(() => {
    getSecurityImages();
  }, []);

  const handleImageSelect = (imageId: any) => {
    selectSecurityImages(imageId);
  };

  const handleSubmit = async () => {
    if (!selectedImage) {
      return;
    }

    const success = await insertSecurityImages(userInfo.systemUserId, selectedImage);

    if (success) {
      setOpenDialog(true);
    }
  };

  const handleDialogClose = () => {
    setOpenDialog(false);
    window.location.href = "/login";
  };

  return (
    <Box textAlign="center" p={1} sx={{ mt: 9 }}>
      <Typography variant="h4" fontWeight="bold">
        Güvenlik Resmi Seç
      </Typography>
      <Typography variant="body1" mt={2} mb={4}>
        Güvenlik resmi, bağlantınızın güvenliği ile ilgili bir gösterge olup kontrol amaçlı bir
        resim seçmeniz gerekmektedir. UPT Kurumsal İnternet Şube’ye girişlerinizde seçiminizden
        farklı bir resim görürseniz giriş yapmayınız ve kurumsalsube@upt.com.tr adresine mail atarak
        bildiriniz.
      </Typography>

      <Grid container spacing={1} justifyContent="center">
        {images.map((image: any) => (
          <Grid item xs={3} key={image.securityImageId} textAlign="center">
            <Box
              sx={{
                border:
                  selectedImage === image.securityImageId
                    ? "3px solid #1976d2"
                    : "2px solid transparent",
                borderRadius: "8px",
                cursor: "pointer",
                transition: "0.3s",
                padding: "5px",
              }}
              onClick={() => handleImageSelect(image.securityImageId)}
            >
              <Image
                src={image.path}
                alt={image.imageName}
                layout="responsive"
                width={100}
                height={109}
                objectFit="contain"
              />
            </Box>
            <Radio
              checked={String(selectedImage) === String(image.securityImageId)}
              onChange={() => handleImageSelect(image.securityImageId)} // ✅ Seçildiğinde state güncelleniyor
              color="primary"
            />
          </Grid>
        ))}
      </Grid>

      <Button
        variant="contained"
        sx={{ mt: 4, px: 5, py: 2 }}
        disabled={!selectedImage} // Kullanıcı resim seçmezse buton disable olur
        onClick={handleSubmit}
      >
        Devam Et
      </Button>
      <MessageDialog
        open={openDialog}
        title="Güvenlik Resim Güncelleme"
        message="Güvenlik resminiz başarıyla güncellenmiştir."
        onClose={handleDialogClose}
      />
    </Box>
  );
}
